import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { PageSection } from '../PageSection';
import { FlowSteps } from '../FlowSteps';
import { familiarProblems } from '../../data/salesContent';
export function ProblemSection() {
  return <PageSection labelledBy="familiar-title" data-id="element-148" data-mp="8kjsj7c7ge7k">
      <SectionHeading id="familiar-title" title="¿Te suena familiar?" subtitle={<>
            <p data-id="element-150" data-mp="3vpj9tel0vnym">Tenés un auto y lo usás todos los días...</p>
            <p data-id="element-151" data-mp="3vnyf9oypk50r">pero cuando aparece algo fuera de lo normal, empiezan las dudas.</p>
          </>} data-id="element-149" data-mp="djmwspkd2geh" />
      <div className="mt-8 space-y-5" data-id="element-152" data-mp="3na5fycagemw">
        {familiarProblems.map(({
        icon: Icon,
        ...p
      }) => <article key={p.title} className="rounded-2xl border border-zinc-800 bg-zinc-950 p-6 md:p-7" data-id="element-153" data-mp="3lt6dsa208y0p">
            <div className="flex items-start gap-3" data-id="element-154" data-mp="3qsj10vwsg73t">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-cyan-500/10 text-cyan-400" data-id="element-155" data-mp="1jzpa1hgzwhb8">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-156" data-mp="1oyjrog387ztr" />
              </span>
              <h3 className="pt-1 font-display text-lg font-extrabold uppercase leading-tight text-white md:text-xl" data-id="element-157" data-mp="1nmt4t46qsrmj">{p.title}</h3>
            </div>

            {p.tagStyle === 'chips' ? <ul className="mt-5 flex flex-wrap gap-2" data-id="element-158" data-mp="1wgo6g28nnzxf">
                {p.tags.map(t => <li key={t} className="rounded-full border border-zinc-700 px-3 py-1 text-sm font-medium text-zinc-200" data-id="element-159" data-mp="1sejgpelbvng2">
                    {t}
                  </li>)}
              </ul> : <ul className="mt-5 space-y-1.5" data-id="element-160" data-mp="14p8nqja7yxch">
                {p.tags.map(t => <li key={t} className="flex items-center gap-2.5 text-base font-medium text-zinc-200" data-id="element-161" data-mp="zqxcq586ugso">
                    <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-cyan-500" aria-hidden="true" data-id="element-162" data-mp="1dqg9y2zgo7q7" />
                    {t}
                  </li>)}
              </ul>}

            {p.question && <div className="mt-5" data-id="element-163" data-mp="2p40ukgugsfsu">
                <p className="text-base text-zinc-400" data-id="element-164" data-mp="2p2z8ziftoawv">{p.question.lead}</p>
                <p className="mt-1 font-display text-2xl font-extrabold uppercase text-cyan-400 md:text-3xl" data-id="element-165" data-mp="2k4xnyryu61ir">{p.question.text}</p>
              </div>}

            <div className="mt-4 space-y-2 text-base leading-relaxed text-zinc-300 md:text-[17px]" data-id="element-166" data-mp="1mre3scqb6sth">
              {p.paragraphs.map(par => <p key={par} data-id="element-167" data-mp="1qshfqo58k4pf">{par}</p>)}
            </div>

            {p.flow && <FlowSteps steps={p.flow} align="start" className="mt-3" data-id="element-168" data-mp="1qr6h12qndn56" />}

            {p.closing && <div className="mt-5 rounded-xl bg-cyan-500/10 px-5 py-4 font-display text-base font-extrabold uppercase leading-snug md:text-lg" data-id="element-169" data-mp="1vpzs6oigp226">
                <p className="text-white" data-id="element-170" data-mp="132n7kjvv34bi">{p.closing[0]}</p>
                <p className="text-cyan-400" data-id="element-171" data-mp="1312bgptwfdbj">{p.closing[1]}</p>
              </div>}
          </article>)}
      </div>
    </PageSection>;
}